import { useState, useCallback } from "react";
import {EventInteractionType, ws} from "../events/ws";
import {log} from "../utils/log";

interface UseShareProps {
  shareUrl?: string;
  widgetLocation?: string | null;
}

interface UseShareReturn {
  handleShare: () => void;
  shareUrlLabel: string;
}

export function useShare({ shareUrl, widgetLocation }: UseShareProps): UseShareReturn {
  const [shareUrlLabel, setShareUrlLabel] = useState<string>("");

  const handleShare = useCallback(() => {
    const url = shareUrl ?? widgetLocation ?? window.location.href;
    const shareData: ShareData = {
      url,
      title: "Share this video experience!",
    };

    if (navigator.canShare && navigator.canShare(shareData)) {
      ws.sendEvent(EventInteractionType.SOCIAL_SHARE);
      navigator
        .share(shareData)
        .then(() => log("Sharing successful"))
        .catch(() => log("Sharing failed"));
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(
        () => {
          setShareUrlLabel("Url copied");
          setTimeout(() => setShareUrlLabel(""), 1200);
        },
        () => log("cannot copy url")
      );
    }
  }, [shareUrl, widgetLocation, ws])

  return { handleShare, shareUrlLabel }
}
